import React, { useCallback, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import {
  emailWOValueValidator,
  phoneWOValueValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import ShadowCard from "../../components/common/ShadowCard";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import FormDatePicker from "../../components/formFields/FormDateField";
import {
  getAccountByID,
  getAllPaymentAndReceipt,
  getAllSPDCIncremental,
} from "../account/services/account.services";
import { getAllItemIncremental } from "../Item/services/item.services";
import { findAllActiveUnit } from "../unit/services/unit.services";
import ButtonForAll from "../../components/common/Button";
import { clearItemList } from "../Item/itemSlice";
import FormIncrementalSearch from "../../components/formFields/FormIncrementalSearch";
import {
  createPurchase,
  generatePurchaseNoForPurchase,
  getAllDutyAndTaxLedgeAccount,
  // getAllPurchaseLedgeAccount,
  getPurchaseByID,
  updatePurchase,
} from "./services/purchase.services";
import {
  clearPurchaseDetails,
  setPurchaseStateForGST,
  setGeneratedPurchaseNo,
} from "./purchaseSlice";
import { getAllActiveGST } from "../gst/services/gst.services";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { FINANCIAL_YEAR, GUJARATIDFORGST } from "../../_contstants/common";
import moment from "moment";
import {
  getAllLimitedInwards,
  getInwardByID,
} from "../inward/services/inward.services";
import PurchaseItemDetailsArray from "./PurchaseItemDetailsArray";
import { clearInwardDetails } from "../inward/inwardSlice";
import { getAllActiveCities } from "../city/services/city.services";
import AlertBox from "../../components/common/AlertBox";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import {
  calculateAmount,
  calculateGST,
  formatIndianNumber,
  formatIndianNumberForQty,
} from "../../_helper/helper";
import { openDialog } from "../../components/dialog/dialogSlice";
import { getAllActiveStates } from "../state/services/state.services";
import { IState } from "../state/stateModel";
import { getPurchaseRegisterReport } from "../reports/services/reports.services";
import DutyAndTaxDetailsArray from "./DutyAndTaxArray";
import { ErrorToast } from "../../components/toast/Toasts";
import { sumBy } from "lodash";
import { IVoucherType } from "../vouchertype/voucherTypeModel";
import { findAllVoucherTypeByType } from "../vouchertype/services/voucherType.services";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const QtyChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const purchase_items = formRenderProps.valueGetter("purchase_items");

  const purchase_duty_and_taxes = formRenderProps.valueGetter(
    "purchase_duty_and_taxes"
  );

  const taxable_amount = formRenderProps.valueGetter("taxable_amount");
  const sub_total = formRenderProps.valueGetter("sub_total");
  const round_off = formRenderProps.valueGetter("round_off");
  const PurchaseStateForGST = useAppSelector(
    (state) => state.purchase.PurchaseStateForGST
  );
  const AccountPaymentAndReceiptList = useAppSelector(
    (state) => state.account.AccountPaymentAndReceiptList
  );
  const UnitList = useAppSelector((state) => state.unit.UnitList);

  useEffect(() => {
    let totalGSTamount = 0;
    let totalGST5 = 0;
    let totalGST12 = 0;
    let totalGST18 = 0;
    let totalGST28 = 0;

    purchase_items?.map((item: any, index: number) => {
      const gst_id = item?.gst_id;
      const amount = item?.amount;
      // const gstid = gst_id ? parseInt(gst_id?.split("--")[1]) : 0;
      const gstid = item?.tax_percentage || 0;
      if (gstid === 5) {
        totalGST5 += (+amount * +gstid) / 100;
      } else if (gstid === 12) {
        totalGST12 += (+amount * +gstid) / 100;
      } else if (gstid === 18) {
        totalGST18 += (+amount * +gstid) / 100;
      } else if (gstid === 28) {
        totalGST28 += (+amount * +gstid) / 100;
      }
      totalGSTamount += (+amount * +gstid) / 100;
      if (!gst_id) {
        formRenderProps.onChange(`purchase_items.${index}.gst_id`, {
          value: null,
        });
      }
    });

    formRenderProps.onChange("gst", {
      value: totalGSTamount || 0,
    });

    if (PurchaseStateForGST === GUJARATIDFORGST) {
      formRenderProps.onChange("cgst", {
        value: totalGSTamount / 2 || 0,
      });
      formRenderProps.onChange("sgst", {
        value: totalGSTamount / 2 || 0,
      });
    } else {
      formRenderProps.onChange("igst", {
        value: totalGSTamount || 0,
      });
    }
    formRenderProps.onChange("gst5", {
      value: totalGST5 || 0,
    });

    formRenderProps.onChange("gst12", {
      value: totalGST12 || 0,
    });
    formRenderProps.onChange("gst18", {
      value: totalGST18 || 0,
    });
    formRenderProps.onChange("gst28", {
      value: totalGST28 || 0,
    });

    // Account Implementation Starts
    const gstConfig = {
      2.5: (isGujarat: boolean) => (isGujarat ? totalGST5 / 2 : 0),
      5: (isGujarat: boolean) => (!isGujarat ? totalGST5 : 0),
      6: (isGujarat: boolean) => (isGujarat ? totalGST12 / 2 : 0),
      12: (isGujarat: boolean) => (!isGujarat ? totalGST12 : 0),
      9: (isGujarat: boolean) => (isGujarat ? totalGST18 / 2 : 0),
      18: (isGujarat: boolean) => (!isGujarat ? totalGST18 : 0),
      14: (isGujarat: boolean) => (isGujarat ? totalGST28 / 2 : 0),
      28: (isGujarat: boolean) => (!isGujarat ? totalGST28 : 0),
    };

    purchase_duty_and_taxes?.map((item: any, index: number) => {
      const legder_id = item?.ledger_id;
      const gst_per = item?.gst_per;
      const ledger_option_data =
        purchase_duty_and_taxes[index].ledger_options?.filter(
          (tax: any) => tax.id === legder_id
        )?.[0] || [];
      const tax_type = ledger_option_data?.tax_type;
      const type_of_supply = ledger_option_data?.type_of_supply;
      const isGujarat = PurchaseStateForGST === GUJARATIDFORGST;
      if (legder_id) {
        if (
          ["igst", "cgst", "sgst"]?.includes(tax_type?.toLowerCase()) &&
          gst_per
        ) {
          const gstAmount = gstConfig[gst_per as keyof typeof gstConfig]
            ? gstConfig[gst_per as keyof typeof gstConfig](isGujarat)
            : 0;
          formRenderProps.onChange(
            `purchase_duty_and_taxes.${index}.gst_amount`,
            {
              value: gstAmount,
            }
          );
        } else if (tax_type?.toLowerCase() === "cess" && gst_per) {
          const applycess = AccountPaymentAndReceiptList?.filter(
            (item: any) => item?.isapplycess
          )?.map((item: any) => item.id);
          const cess_apply_amount = sumBy(
            purchase_items?.filter((item: any) =>
              applycess.includes(item?.purchase_ledger_id)
            ),
            "amount"
          );
          formRenderProps.onChange(
            `purchase_duty_and_taxes.${index}.gst_amount`,
            {
              value: (cess_apply_amount * gst_per) / 100,
            }
          );
        } else if (type_of_supply === "Service" && gst_per) {
          formRenderProps.onChange(
            `purchase_duty_and_taxes.${index}.gst_amount`,
            {
              value: (taxable_amount * gst_per) / 100,
            }
          );
        } else {
          if (gst_per) {
            formRenderProps.onChange(
              `purchase_duty_and_taxes.${index}.gst_amount`,
              {
                value: (taxable_amount * gst_per) / 100,
              }
            );
          }
        }
      }
    });

    // purchase_duty_and_taxes?.forEach((item: any, index: number) => {
    //   const gst_per = item?.gst_per;
    //   // const ledger_name = item?.ledger_name;
    //   const ledger_data =
    //     purchase_duty_and_taxes[index].ledger_options?.filter(
    //       (tax: any) => tax.id === item?.ledger_id
    //     ) || [];
    //   const tax_type = ledger_data[0]?.tax_type || "";
    //   const typeOfSupply = ledger_data[0]?.type_of_supply || "";
    //   formRenderProps.onChange(`purchase_duty_and_taxes.${index}.tax_type`, {
    //     value: tax_type,
    //   });

    //   const isGujarat = PurchaseStateForGST === GUJARATIDFORGST;
    //   if (item?.ledger_id) {
    //     if (tax_type?.toLowerCase()?.includes("gst")) {
    //       let gstAmount =
    //         gst_per && gstConfig[gst_per as keyof typeof gstConfig]
    //           ? gstConfig[gst_per as keyof typeof gstConfig](isGujarat)
    //           : 0;
    //       if (typeOfSupply === "Service") {
    //         if (item?.gst_per) {
    //           formRenderProps.onChange(
    //             `purchase_duty_and_taxes.${index}.gst_amount`,
    //             {
    //               value: (taxable_amount * item?.gst_per) / 100,
    //             }
    //           );
    //         }
    //       } else {
    //         formRenderProps.onChange(
    //           `purchase_duty_and_taxes.${index}.gst_amount`,
    //           {
    //             value: gstAmount,
    //           }
    //         );
    //       }
    //     } else if (tax_type?.toLowerCase()?.includes("cess")) {
    //       if (gst_per) {
    //         const applycess = AccountPaymentAndReceiptList?.filter(
    //           (item: any) => item?.isapplycess
    //         )?.map((item: any) => item.id);
    //         const cess_apply_amount = sumBy(
    //           purchase_items?.filter((item: any) =>
    //             applycess.includes(item.purchase_ledger_id)
    //           ),
    //           "amount"
    //         );
    //         formRenderProps.onChange(
    //           `purchase_duty_and_taxes.${index}.gst_amount`,
    //           {
    //             value: (cess_apply_amount * gst_per) / 100,
    //           }
    //         );
    //       }
    //     } else {
    //       if (gst_per) {
    //         formRenderProps.onChange(
    //           `purchase_duty_and_taxes.${index}.gst_amount`,
    //           {
    //             value: (taxable_amount * gst_per) / 100,
    //           }
    //         );
    //       }
    //     }
    //   } else {
    //     formRenderProps.onChange(
    //       `purchase_duty_and_taxes.${index}.gst_amount`,
    //       {
    //         value: 0,
    //       }
    //     );
    //     formRenderProps.onChange(`purchase_duty_and_taxes.${index}.gst_per`, {
    //       value: 0,
    //     });
    //   }
    // });

    const grandTotals = purchase_duty_and_taxes?.reduce(
      (acc: Record<string, number>, item: any, index: number) => {
        // const firstWord = item?.ledger_name?.split(" ")[0];
        const firstWord =
          purchase_duty_and_taxes[index].ledger_options?.filter(
            (tax: any) => tax.id === item?.ledger_id
          )[0]?.tax_type ||
          purchase_duty_and_taxes[index].ledger_options?.filter(
            (tax: any) => tax.id === item?.ledger_id
          )[0]?.account_name ||
          "";

        acc[firstWord] = (acc[firstWord] || 0) + item?.gst_amount;
        acc["duty_tax_total"] = (acc["duty_tax_total"] || 0) + item?.gst_amount;
        acc["sub_total"] =
          (acc["duty_tax_total"] || 0) + (+taxable_amount || 0);
        return acc;
      },
      {} as Record<string, number>
    );

    formRenderProps.onChange("sub_total", {
      value: grandTotals?.sub_total || 0,
    });

    formRenderProps.onChange("dutytaxtotal", {
      value:
        (
          (grandTotals?.CGST || 0) +
          (grandTotals?.SGST || 0) +
          (grandTotals?.IGST || 0)
        )?.toFixed(2) || 0,
    });

    if (PurchaseStateForGST === GUJARATIDFORGST) {
      formRenderProps.onChange("cgst", {
        value: grandTotals?.CGST || 0,
      });
      formRenderProps.onChange("sgst", {
        value: grandTotals?.SGST || 0,
      });
      formRenderProps.onChange("gst", {
        value: +(+grandTotals?.CGST + +grandTotals?.SGST)?.toFixed(2) || 0,
      });
    } else {
      formRenderProps.onChange("igst", {
        value: grandTotals?.IGST || 0,
      });
      formRenderProps.onChange("gst", {
        value: +grandTotals?.IGST?.toFixed(2) || 0,
      });
    }

    // Account Implementation Ends
  }, [
    PurchaseStateForGST,
    taxable_amount,
    // purchase_items?.map((item: any) => item?.gst_id).join("-"),
    purchase_items?.map((item: any) => item?.tax_percentage).join("-"),
    purchase_items?.map((item: any) => item?.amount).join("-"),
    // purchase_duty_and_taxes?.map((item: any) => item?.ledger_id).join("-"),
    purchase_duty_and_taxes?.map((item: any) => item?.gst_per).join("-"),
    purchase_duty_and_taxes?.map((item: any) => item?.gst_amount).join("-"),
  ]);

  useEffect(() => {
    if (purchase_items && purchase_items.length > 0) {
      purchase_items.forEach((item: any, index: number) => {
        const quantity = parseFloat(
          item?.quantity?.toFixed(item?.unit_decimal || 0) || "0"
        );
        const rate = item?.rate || 0;
        const discount = item?.discount || 0;
        const discountType = item?.discount_type || "₹";

        // const gstIdStr = item?.gst_id;
        // const gstid = gstIdStr ? parseInt(gstIdStr.split("--")[1], 10) : 0;
        const gstid = item?.tax_percentage || 0;

        const amount = calculateAmount(quantity, rate, discount, discountType);
        const gstDetails = calculateGST(
          amount,
          gstid,
          PurchaseStateForGST === GUJARATIDFORGST
        );
        // Update the form fields
        const updates: Record<string, any> = {
          [`purchase_items.${index}.amount`]: { value: amount },
          [`purchase_items.${index}.sgst_amount`]: {
            value: gstDetails.sgstAmount,
          },
          [`purchase_items.${index}.cgst_amount`]: {
            value: gstDetails.cgstAmount,
          },
          [`purchase_items.${index}.igst_amount`]: {
            value: gstDetails.igstAmount,
          },
          [`purchase_items.${index}.total_gst_amount`]: {
            value:
              gstDetails.sgstAmount +
              gstDetails.cgstAmount +
              gstDetails.igstAmount,
          },
          [`purchase_items.${index}.sgst_per`]: { value: gstDetails.sgstPer },
          [`purchase_items.${index}.cgst_per`]: { value: gstDetails.cgstPer },
          [`purchase_items.${index}.igst_per`]: { value: gstDetails.igstPer },
        };

        // Apply all updates
        Object.entries(updates).forEach(([key, update]) => {
          formRenderProps.onChange(key, update);
        });
      });
    }
  }, [
    PurchaseStateForGST,
    // purchase_items?.map((item: any) => item?.gst_id).join("-"),
    purchase_items?.map((item: any) => item?.tax_percentage).join("-"),
    purchase_items.map((item: any) => item?.quantity).join("-"),
    purchase_items.map((item: any) => item?.rate).join("-"),
    purchase_items.map((item: any) => item?.discount).join("-"),
    purchase_items.map((item: any) => item?.discount_type).join("-"),
    purchase_items.map((item: any) => item?.unit_decimal).join("-"),
  ]);

  let totalamount = 0;
  let totalQty = 0;

  useEffect(() => {
    if (purchase_items && purchase_items.length > 0) {
      purchase_items?.map((item: any) => {
        totalQty += +item?.quantity || 0;
        totalamount += +item?.amount || 0;
      });
    }
    formRenderProps.onChange("totalQty", {
      value: totalQty,
    });
    formRenderProps.onChange("taxable_amount", {
      value: totalamount,
    });
  }, [
    purchase_items.map((item: any) => item?.quantity).join("-"),
    purchase_items.map((item: any) => item?.amount).join("-"),
  ]);

  useEffect(() => {
    if (purchase_items && purchase_items.length > 0) {
      purchase_items?.map((item: any, index: number) => {
        const unit_id = item?.unit_id;

        const unit = UnitList.find((unit: any) => unit?.id === unit_id);
        if (unit) {
          formRenderProps.onChange(`purchase_items.${index}.unit_decimal`, {
            value: unit?.unit_decimal || 0,
          });
        } else {
          formRenderProps.onChange(`purchase_items.${index}.unit_decimal`, {
            value: 0,
          });
        }
      });
    }
  }, [purchase_items.map((item: any) => item?.unit_id).join("-")]);

  useEffect(() => {
    formRenderProps.onChange("round_off", {
      value: Math.round(+sub_total) - +sub_total,
    });
    formRenderProps.onChange("grand_total", {
      value: +sub_total + +round_off || 0,
    });
  }, [sub_total, round_off]);

  return null;
};

const VendorChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const purchase_guid = location.state?.purchase_guid;
  const vendor_id = formRenderProps.valueGetter("vendor_id");
  const isVendorRef = useRef(true);

  useEffect(() => {
    if (vendor_id) {
      const handleVendorChange = async () => {
        const payload = {
          id: vendor_id,
        };
        const response = await dispatch(getAccountByID(payload));
        if (response.meta.requestStatus === "fulfilled") {
          dispatch(setPurchaseStateForGST(response.payload?.state_id));
          formRenderProps.onChange("state_id", {
            value: response.payload?.state_id,
          });
          formRenderProps.onChange("terms_days", {
            value: response.payload?.payment_due_days,
          });
          formRenderProps.onChange("email_id", {
            value: response.payload?.email,
          });
          formRenderProps.onChange("mobile_no", {
            value: response.payload?.mobile_number,
          });
          formRenderProps.onChange("place_of_supply_id", {
            value: response.payload?.state_id,
          });
          // formRenderProps.onChange("pan_no", {
          //   value: response.payload?.pan_no,
          // });
          // formRenderProps.onChange("gst_no", {
          //   value: response.payload?.gst_no,
          // });
        } else {
          formRenderProps.onChange("state_id", {
            value: null,
          });
          formRenderProps.onChange("terms_days", {
            value: null,
          });
          formRenderProps.onChange("email_id", {
            value: null,
          });
          formRenderProps.onChange("mobile_no", {
            value: null,
          });
          formRenderProps.onChange("place_of_supply_id", {
            value: null,
          });
          // formRenderProps.onChange("pan_no", {
          //   value: null,
          // });
          // formRenderProps.onChange("gst_no", {
          //   value: null,
          // });
        }
      };
      if (!isVendorRef.current) {
        handleVendorChange();
      } else {
        if (!purchase_guid) {
          handleVendorChange();
        }
        isVendorRef.current = false;
      }
    } else {
      dispatch(setPurchaseStateForGST(null));
      formRenderProps.onChange("state_id", {
        value: "",
      });
      formRenderProps.onChange("terms_days", {
        value: "",
      });
      formRenderProps.onChange("email_id", {
        value: "",
      });
      formRenderProps.onChange("mobile_no", {
        value: "",
      });
      formRenderProps.onChange("place_of_supply_id", {
        value: "",
      });
      // formRenderProps.onChange("pan_no", {
      //   value: "",
      // });
      // formRenderProps.onChange("gst_no", {
      //   value: "",
      // });
    }
  }, [vendor_id]);

  return null;
};

const DateChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const location = useLocation();
  const purchase_guid = location.state?.purchase_guid;
  const invoice_date = formRenderProps.valueGetter("invoice_date");
  const terms_days = formRenderProps.valueGetter("terms_days");
  // const due_date = formRenderProps.valueGetter("due_date");
  const isDateRef = useRef(true);

  useEffect(() => {
    const changeDueDate = () => {
      if (terms_days) {
        const dueDate = moment(invoice_date, "YYYY-MM-DD").add(
          terms_days || 0,
          "days"
        );

        formRenderProps.onChange("due_date", {
          value: moment(dueDate).toDate() || "",
        });
      }
      if (!terms_days) {
        formRenderProps.onChange("terms_days", {
          value: "",
        });
        formRenderProps.onChange("due_date", {
          value: "",
        });
      }
    };

    if (!isDateRef.current) {
      changeDueDate();
    } else {
      if (!purchase_guid) {
        changeDueDate();
      }
      isDateRef.current = false;
    }
  }, [invoice_date, terms_days]);

  return null;
};

const PurchaseNoChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const purchase_guid = location.state?.purchase_guid;
  // const isPurchaseNoRef = useRef(false);
  const voucher_type_id = formRenderProps.valueGetter("voucher_type_id");
  const purchase_no_string = formRenderProps.valueGetter("purchase_no_string");
  const PurchaseDetail = useAppSelector(
    (state) => state.purchase.PurchaseDetail
  );
  const GeneratedPurchaseNo = useAppSelector(
    (state) => state.purchase.GeneratedPurchaseNo
  );

  useEffect(() => {
    const fetchInvoiceNoDate = async (voucher_type_id: number) => {
      const payload = {
        financial_year: FINANCIAL_YEAR,
        voucher_type_id: +voucher_type_id,
      };

      const response = await dispatch(generatePurchaseNoForPurchase(payload));

      if (response.meta.requestStatus === "fulfilled") {
        dispatch(setGeneratedPurchaseNo(response.payload?.purchase_no_string));
        formRenderProps.onChange("purchase_no_string", {
          value: response.payload?.purchase_no_string || "",
        });
      }
    };
    // if (!isPurchaseNoRef.current) {
    if (!purchase_guid && voucher_type_id) {
      fetchInvoiceNoDate(voucher_type_id);
    }
    //   isPurchaseNoRef.current = true;
    // } else {
    //   isPurchaseNoRef.current = true;
    // }
  }, [voucher_type_id]);

  useEffect(() => {
    const updateInvoiveNoDate = async () => {
      const purchaseNoString = purchase_guid
        ? PurchaseDetail?.purchase_no_string
        : GeneratedPurchaseNo;
      const oldkey = purchaseNoString?.split("/")?.slice(0, -1).join("/");
      if (
        purchaseNoString?.split("/").length ===
          purchase_no_string?.split("/").length &&
        voucher_type_id
      ) {
        const modifiyed = purchase_no_string?.split("/")?.pop();
        formRenderProps.onChange("purchase_no_string", {
          value: `${oldkey}/${modifiyed}`,
        });
        formRenderProps.onChange("purchase_no", {
          value: `${modifiyed}`,
        });
      } else {
        if (voucher_type_id) {
          formRenderProps.onChange("purchase_no_string", {
            value: `${oldkey}/`,
          });
        } else {
          formRenderProps.onChange("purchase_no_string", {
            value: "",
          });
        }
        formRenderProps.onChange("purchase_no", {
          value: null,
        });
      }
    };

    updateInvoiveNoDate();
  }, [purchase_no_string, voucher_type_id]);

  return null;
};

const CreatePurchase = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const purchase_guid = location.state?.purchase_guid;
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.purchase.loading);
  const StateList = useAppSelector((state) => state.state.StateList);
  const PurchaseDetail = useAppSelector(
    (state) => state.purchase.PurchaseDetail
  );
  const PurchaseStateForGST = useAppSelector(
    (state) => state.purchase.PurchaseStateForGST
  );

  const InwardList = useAppSelector((state) => state.inward.InwardList);
  const PurchaseRegisterDetails = useAppSelector(
    (state) => state.reports.PurchaseRegisterDetails
  );
  const AccountPaymentAndReceiptList = useAppSelector(
    (state) => state.account.AccountPaymentAndReceiptList
  );
  const VoucherTypeList = useAppSelector(
    (state) => state.voucherType.VoucherTypeList
  );

  const [formKey, setFormKey] = React.useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [PurchaseDetail]);

  useEffect(() => {
    if (purchase_guid) {
      const payload = {
        purchase_guid: purchase_guid,
      };
      dispatch(getPurchaseByID(payload));
    }
  }, [purchase_guid]);

  useEffect(() => {
    const payload = {
      financial_year: FINANCIAL_YEAR,
    };
    const PurchaseAccountPayload = {
      account_name: "",
      under_group_id: "14",
    };

    dispatch(findAllActiveUnit());
    dispatch(getAllActiveGST());
    dispatch(getAllActiveCities());
    dispatch(getAllActiveStates());
    // dispatch(getAllActiveAccountGroup());
    dispatch(findAllVoucherTypeByType(2));
    dispatch(getAllLimitedInwards(payload));
    dispatch(getAllPaymentAndReceipt(PurchaseAccountPayload));

    return () => {
      dispatch(clearPurchaseDetails());
      dispatch(clearInwardDetails());
      dispatch(clearItemList());
    };
  }, []);

  useEffect(() => {
    const fetchAccountDetails = async () => {
      const payload = {
        id: PurchaseDetail?.vendor_id,
      };
      const response = await dispatch(getAccountByID(payload));
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(setPurchaseStateForGST(response.payload?.state_id));
      } else {
        dispatch(setPurchaseStateForGST(null));
      }
    };
    if (PurchaseDetail?.vendor_id) {
      fetchAccountDetails();
    }
  }, [PurchaseDetail]);

  const handleChallanNoChange = async (
    inward_no: any,
    formRenderProps: FormRenderProps
  ) => {
    if (inward_no) {
      const payload = {
        inward_no: inward_no,
        financial_year: FINANCIAL_YEAR,
      };
      const response = await dispatch(getInwardByID(payload));
      if (response.meta.requestStatus === "fulfilled") {
        formRenderProps.onChange("vendor_id", {
          value: response.payload?.vendor_id,
        });
        formRenderProps.onChange("po_no", {
          value: response.payload?.po_no,
        });
        formRenderProps.onChange("vendor_options", {
          value: response.payload?.vendor_options,
        });
        formRenderProps.onChange("invoice_no", {
          value: response.payload?.bill_no,
        });
        formRenderProps.onChange("invoice_date", {
          value: response.payload?.bill_date,
        });
        const purchaseItems =
          response.payload?.inward_items &&
          response.payload?.inward_items.length > 0 &&
          response.payload?.inward_items?.map((item: any) => {
            const result =
              AccountPaymentAndReceiptList?.filter((ledger: any) => {
                return ledger?.tax_percentage === item?.gst;
              }) || [];

            return {
              item_id: item?.item_id,
              item_options: item?.item_options,
              quantity: item?.weight,
              unit_id: item?.unit_id,
              unit_decimal: item?.unit_decimal,
              rate: item?.rate,
              discount: item?.discount,
              discount_type: item?.discount_type,
              // gst_id: item?.gst_id,
              purchase_ledger_id: result?.length > 0 ? result[0]?.id : null,
              tax_percentage:
                result?.length > 0 ? result[0]?.tax_percentage : 0,
              amount: item?.total,
            };
          });
        formRenderProps.onChange("purchase_items", {
          value: purchaseItems || [],
        });
        const purchaseDutiesAndTaxesItems =
          response.payload?.inward_duty_and_taxes &&
          response.payload?.inward_duty_and_taxes.length > 0 &&
          response.payload?.inward_duty_and_taxes?.map((item: any) => {
            return {
              ledger_id: item?.ledger_id,
              ledger_name: item?.ledger_name,
              gst_per: item?.gst_per,
              ledger_options: item?.ledger_options,
            };
          });
        formRenderProps.onChange("purchase_duty_and_taxes", {
          value: purchaseDutiesAndTaxesItems || [{}],
        });
      } else {
        formRenderProps.onChange("vendor_id", {
          value: null,
        });
        formRenderProps.onChange("po_no", {
          value: null,
        });
        formRenderProps.onChange("vendor_options", {
          value: [],
        });
      }
    }
  };

  const handleItemSearchChange = useCallback(
    async (search: string, field: string, formRenderProps: FormRenderProps) => {
      const result = await dispatch(getAllItemIncremental({ search }));
      formRenderProps.onChange(field, {
        value: result.payload,
      });
    },
    [dispatch]
  );

  const handleLedgerSearchChange = useCallback(
    async (search: string, field: string, formRenderProps: FormRenderProps) => {
      const result = await dispatch(getAllDutyAndTaxLedgeAccount(search));
      formRenderProps.onChange(field, {
        value: result.payload,
      });
    },
    [dispatch]
  );

  const handleVendorSearchChange = useCallback(
    async (search: string, field: string, formRenderProps: FormRenderProps) => {
      const result = await dispatch(getAllSPDCIncremental(search));
      formRenderProps.onChange(field, {
        value: result.payload,
      });
    },
    [dispatch]
  );

  // const handlePurchaseLedgerSearchChange = useCallback(
  //   async (search: string, field: string, formRenderProps: FormRenderProps) => {
  //     const result = await dispatch(getAllPurchaseLedgeAccount(search));
  //     formRenderProps.onChange(field, {
  //       value: result.payload,
  //     });
  //   },
  //   [dispatch]
  // );

  const handleSubmit = async (values: any) => {
    let totalGST = 0;
    values?.purchase_items &&
      values?.purchase_items?.map(
        (sales: any) =>
          (totalGST +=
            sales?.cgst_amount + sales?.sgst_amount + sales?.igst_amount)
      );
    if (values?.purchase_no_string?.endsWith("/")) {
      ErrorToast("Please Enter Puchase Number.");
      return;
    }

    if (Math.ceil(+totalGST?.toFixed(2)) !== Math.ceil(+values?.dutytaxtotal)) {
      ErrorToast("Mismatch in Tax!");
    } else {
      if (purchase_guid) {
        try {
          const updatePayload: any = {
            id: values?.id ? +values?.id : null,
            purchase_guid: purchase_guid,
            // purchase_challan_id: values?.purchase_challan_id
            //   ? +values?.purchase_challan_id
            //   : null,
            financial_year: FINANCIAL_YEAR,
            voucher_type_id: values?.voucher_type_id
              ? +values?.voucher_type_id
              : null,
            purchase_no_string: values?.purchase_no_string
              ? values?.purchase_no_string
              : "",
            purchase_no: values?.purchase_no ? +values?.purchase_no : null,
            inward_no: values?.inward_no ? +values?.inward_no : null,
            mobile_no: values?.mobile_no ? `${values?.mobile_no}` : "",
            email_id: values?.email_id ? values?.email_id : "",
            // pan_no: values?.pan_no ? values?.pan_no : "",
            // gst_no: values?.gst_no ? values?.gst_no : "",
            invoice_no: values?.invoice_no ? values?.invoice_no : "",
            cartoon: values?.cartoon ? +values?.cartoon : null,
            bag: values?.bag ? +values?.bag : null,
            vehicle_no: values?.vehicle_no ? values?.vehicle_no : "",
            transport_name: values?.transport_name
              ? values?.transport_name
              : "",
            delivery_slip_no: values?.delivery_slip_no
              ? values?.delivery_slip_no
              : "",
            invoice_date: values?.invoice_date
              ? moment(values?.invoice_date).format("YYYY-MM-DD")
              : "",
            vendor_id: values?.vendor_id ? +values?.vendor_id : null,
            terms_days: values?.terms_days ? +values?.terms_days : null,
            due_date: values?.due_date
              ? moment(values?.due_date).format("YYYY-MM-DD")
              : null,
            place_of_supply_id: values?.place_of_supply_id
              ? +values?.place_of_supply_id
              : null,
            // purchase_ledger_id: values?.purchase_ledger_id
            //   ? +values?.purchase_ledger_id
            //   : null,
            packing: values?.packing ? +values?.packing?.toFixed(2) : null,
            labour: values?.labour ? +values?.labour?.toFixed(2) : null,
            dalali: values?.dalali ? +values?.dalali?.toFixed(2) : null,
            taxable_amount: values?.taxable_amount
              ? +values?.taxable_amount
              : null,
            total_amount: values?.grand_total ? +values?.grand_total : null,
            sub_total: values?.sub_total
              ? +values?.sub_total?.toFixed(2)
              : null,
            round_off: values?.round_off
              ? +values?.round_off?.toFixed(2)
              : null,
            gst: values?.gst ? +values?.gst?.toFixed(2) : 0,
            purchase_items: values?.purchase_items
              ? values?.purchase_items?.map((purchaseitem: any) => {
                  return {
                    id: purchaseitem?.id ? +purchaseitem?.id : 0,
                    purchase_id: values?.id ? +values?.id : null,
                    item_id: purchaseitem?.item_id
                      ? +purchaseitem?.item_id
                      : null,
                    // mrp: purchaseitem?.mrp ? +purchaseitem?.mrp : null,
                    quantity: purchaseitem?.quantity
                      ? +purchaseitem?.quantity?.toFixed(
                          purchaseitem.unit_decimal
                            ? purchaseitem.unit_decimal
                            : 0
                        )
                      : 0,
                    free_quantity: purchaseitem?.free_quantity
                      ? +purchaseitem?.free_quantity?.toFixed(
                          purchaseitem.unit_decimal
                            ? purchaseitem.unit_decimal
                            : 0
                        )
                      : 0,
                    unit_id: purchaseitem?.unit_id
                      ? +purchaseitem?.unit_id
                      : null,
                    rate: purchaseitem?.rate ? +purchaseitem?.rate : null,
                    discount: purchaseitem?.discount
                      ? +purchaseitem?.discount
                      : null,
                    discount_type: purchaseitem?.discount_type === "%" ? 2 : 1,
                    purchase_ledger_id: purchaseitem?.purchase_ledger_id
                      ? +purchaseitem?.purchase_ledger_id
                      : null,
                    gst_id:
                      //  purchaseitem?.gst_id
                      //   ? parseInt(purchaseitem?.gst_id.split("--")[0])
                      //   :
                      null,

                    sgst_per: purchaseitem?.sgst_per
                      ? +purchaseitem?.sgst_per?.toFixed(2)
                      : 0,
                    sgst_amount: purchaseitem?.sgst_amount
                      ? +purchaseitem?.sgst_amount?.toFixed(2)
                      : 0,
                    cgst_per: purchaseitem?.cgst_per
                      ? +purchaseitem?.cgst_per?.toFixed(2)
                      : 0,
                    cgst_amount: purchaseitem?.cgst_amount
                      ? +purchaseitem?.cgst_amount?.toFixed(2)
                      : 0,
                    igst_per: purchaseitem?.igst_per
                      ? +purchaseitem?.igst_per?.toFixed(2)
                      : 0,
                    igst_amount: purchaseitem?.igst_amount
                      ? +purchaseitem?.igst_amount?.toFixed(2)
                      : 0,
                    total_gst_amount: purchaseitem?.total_gst_amount
                      ? +purchaseitem?.total_gst_amount?.toFixed(2)
                      : 0,
                    amount: purchaseitem?.amount ? +purchaseitem?.amount : null,
                  };
                })
              : [],

            purchase_duty_and_taxes: values?.purchase_duty_and_taxes
              ? values.purchase_duty_and_taxes
                  .filter(
                    (purchaseduty: any) =>
                      purchaseduty?.ledger_id && purchaseduty?.gst_amount
                  )
                  .map((purchaseduty: any) => ({
                    ledger_id: +purchaseduty.ledger_id,
                    gst_per: purchaseduty?.gst_per
                      ? +purchaseduty.gst_per
                      : null,
                    gst_amount: purchaseduty?.gst_amount
                      ? +purchaseduty.gst_amount
                      : null,
                  }))
              : [],
          };
          if (PurchaseStateForGST === GUJARATIDFORGST) {
            updatePayload.cgst = values?.cgst
              ? +values?.cgst?.toFixed(2)
              : null;
            updatePayload.sgst = values?.sgst
              ? +values?.sgst?.toFixed(2)
              : null;
            updatePayload.igst = null;
          } else {
            updatePayload.igst = values?.igst
              ? +values?.igst?.toFixed(2)
              : null;
            updatePayload.cgst = null;
            updatePayload.sgst = null;
          }

          const response = await dispatch(updatePurchase(updatePayload));
          if (response?.meta?.requestStatus === "fulfilled") {
            // navigate("/purchase");
            if (PurchaseRegisterDetails?.isPurchaseRef) {
              const payload = {
                item_id: PurchaseRegisterDetails?.item_id
                  ? PurchaseRegisterDetails?.item_id
                  : null,
                vendor_id: PurchaseRegisterDetails?.vendor_id
                  ? PurchaseRegisterDetails?.vendor_id
                  : null,
                from_date: PurchaseRegisterDetails?.from_date
                  ? moment(PurchaseRegisterDetails?.from_date).format(
                      "YYYY-MM-DD"
                    )
                  : null,
                to_date: PurchaseRegisterDetails?.to_date
                  ? moment(PurchaseRegisterDetails?.to_date).format(
                      "YYYY-MM-DD"
                    )
                  : null,
                voucher_type_id: PurchaseRegisterDetails?.voucher_type_id
                  ? PurchaseRegisterDetails?.voucher_type_id
                  : null,
              };
              dispatch(getPurchaseRegisterReport(payload));
            }
            navigate(-1);
          }
        } catch (error) {
          console.error("Error in handleSubmit:", error);
          throw error;
        }
      } else {
        try {
          const insertPayload: any = {
            // purchase_challan_id: values?.purchase_challan_id
            //   ? +values?.purchase_challan_id
            //   : null,
            financial_year: FINANCIAL_YEAR,
            voucher_type_id: values?.voucher_type_id
              ? +values?.voucher_type_id
              : null,
            purchase_no_string: values?.purchase_no_string
              ? values?.purchase_no_string
              : "",
            purchase_no: values?.purchase_no ? +values?.purchase_no : null,
            inward_no: values?.inward_no ? +values?.inward_no : null,
            mobile_no: values?.mobile_no ? `${values?.mobile_no}` : "",
            email_id: values?.email_id ? values?.email_id : "",
            // pan_no: values?.pan_no ? values?.pan_no : "",
            // gst_no: values?.gst_no ? values?.gst_no : "",
            invoice_no: values?.invoice_no ? values?.invoice_no : "",
            cartoon: values?.cartoon ? +values?.cartoon : null,
            bag: values?.bag ? +values?.bag : null,
            vehicle_no: values?.vehicle_no ? values?.vehicle_no : "",
            transport_name: values?.transport_name
              ? values?.transport_name
              : "",
            delivery_slip_no: values?.delivery_slip_no
              ? values?.delivery_slip_no
              : "",
            invoice_date: values?.invoice_date
              ? moment(values?.invoice_date).format("YYYY-MM-DD")
              : "",
            vendor_id: values?.vendor_id ? +values?.vendor_id : null,
            terms_days: values?.terms_days ? +values?.terms_days : null,
            due_date: values?.due_date
              ? moment(values?.due_date).format("YYYY-MM-DD")
              : null,
            place_of_supply_id: values?.place_of_supply_id
              ? +values?.place_of_supply_id
              : null,
            // purchase_ledger_id: values?.purchase_ledger_id
            //   ? +values?.purchase_ledger_id
            //   : null,
            packing: values?.packing ? +values?.packing?.toFixed(2) : null,
            labour: values?.labour ? +values?.labour?.toFixed(2) : null,
            dalali: values?.dalali ? +values?.dalali?.toFixed(2) : null,
            taxable_amount: values?.taxable_amount
              ? +values?.taxable_amount
              : null,
            total_amount: values?.grand_total ? +values?.grand_total : null,
            sub_total: values?.sub_total
              ? +values?.sub_total?.toFixed(2)
              : null,
            round_off: values?.round_off
              ? +values?.round_off?.toFixed(2)
              : null,
            gst: values?.gst ? +values?.gst?.toFixed(2) : 0,
            purchase_items: values?.purchase_items
              ? values?.purchase_items?.map((purchaseitem: any) => {
                  return {
                    id: purchaseitem?.id ? +purchaseitem?.id : 0,
                    item_id: purchaseitem?.item_id
                      ? +purchaseitem?.item_id
                      : null,
                    // mrp: purchaseitem?.mrp ? +purchaseitem?.mrp : null,
                    quantity: purchaseitem?.quantity
                      ? +purchaseitem?.quantity?.toFixed(
                          purchaseitem.unit_decimal
                            ? purchaseitem.unit_decimal
                            : 0
                        )
                      : 0,
                    free_quantity: purchaseitem?.free_quantity
                      ? +purchaseitem?.free_quantity?.toFixed(
                          purchaseitem.unit_decimal
                            ? purchaseitem.unit_decimal
                            : 0
                        )
                      : 0,
                    unit_id: purchaseitem?.unit_id
                      ? +purchaseitem?.unit_id
                      : null,
                    rate: purchaseitem?.rate ? +purchaseitem?.rate : null,
                    discount: purchaseitem?.discount
                      ? +purchaseitem?.discount
                      : null,
                    discount_type: purchaseitem?.discount_type === "%" ? 2 : 1,
                    purchase_ledger_id: purchaseitem?.purchase_ledger_id
                      ? +purchaseitem?.purchase_ledger_id
                      : null,
                    gst_id:
                      //  purchaseitem?.gst_id
                      //   ? parseInt(purchaseitem?.gst_id.split("--")[0])
                      //   :
                      null,
                    sgst_per: purchaseitem?.sgst_per
                      ? +purchaseitem?.sgst_per?.toFixed(2)
                      : 0,
                    sgst_amount: purchaseitem?.sgst_amount
                      ? +purchaseitem?.sgst_amount?.toFixed(2)
                      : 0,
                    cgst_per: purchaseitem?.cgst_per
                      ? +purchaseitem?.cgst_per?.toFixed(2)
                      : 0,
                    cgst_amount: purchaseitem?.cgst_amount
                      ? +purchaseitem?.cgst_amount?.toFixed(2)
                      : 0,
                    igst_per: purchaseitem?.igst_per
                      ? +purchaseitem?.igst_per?.toFixed(2)
                      : 0,
                    igst_amount: purchaseitem?.igst_amount
                      ? +purchaseitem?.igst_amount?.toFixed(2)
                      : 0,
                    total_gst_amount: purchaseitem?.total_gst_amount
                      ? +purchaseitem?.total_gst_amount?.toFixed(2)
                      : 0,
                    amount: purchaseitem?.amount ? +purchaseitem?.amount : null,
                  };
                })
              : [],

            purchase_duty_and_taxes: values?.purchase_duty_and_taxes
              ? values.purchase_duty_and_taxes
                  .filter(
                    (purchaseduty: any) =>
                      purchaseduty?.ledger_id && purchaseduty?.gst_amount
                  )
                  .map((purchaseduty: any) => ({
                    ledger_id: +purchaseduty.ledger_id,
                    gst_per: purchaseduty?.gst_per
                      ? +purchaseduty.gst_per
                      : null,
                    gst_amount: purchaseduty?.gst_amount
                      ? +purchaseduty.gst_amount
                      : null,
                  }))
              : [],
          };
          if (PurchaseStateForGST === GUJARATIDFORGST) {
            insertPayload.cgst = values?.cgst
              ? +values?.cgst?.toFixed(2)
              : null;
            insertPayload.sgst = values?.sgst
              ? +values?.sgst?.toFixed(2)
              : null;
            insertPayload.igst = null;
          } else {
            insertPayload.igst = values?.igst
              ? +values?.igst?.toFixed(2)
              : null;
            insertPayload.cgst = null;
            insertPayload.sgst = null;
          }
          const response = await dispatch(createPurchase(insertPayload));
          if (response?.meta?.requestStatus === "fulfilled") {
            // navigate("/purchase");
            navigate(-1);
          }
        } catch (error) {
          console.error("Error in handleSubmit:", error);
          throw error;
        }
      }
    }
  };

  const handleInwardNoChange = async (ev: any) => {
    if (ev?.value) {
      const payload = {
        inward_no: ev?.value,
        financial_year: FINANCIAL_YEAR,
      };
      const res = await dispatch(getInwardByID(payload));
      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(openDialog("inwardItemdetailsView"));
      }
    }
  };

  // if (loading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <InwardChildItemDialog />
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={PurchaseDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 30 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                ]}
              >
                <GridLayoutItem colSpan={4}>
                  <Typography.h4>
                    {purchase_guid ? "Update Purchase" : "Add Purchase"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="voucher_type_id"
                    label="Voucher Type"
                    placeholder="Voucher Type"
                    astrike={true}
                    disabled={purchase_guid && true}
                    validator={requiredValidator}
                    component={FormSelectionField}
                    options={VoucherTypeList?.map((scheme: IVoucherType) => {
                      return {
                        value: scheme?.id,
                        label: scheme?.name,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="purchase_no_string"
                    label="Purchase No"
                    // disabled={true}
                    placeholder="Purchase No"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}></GridLayoutItem>
                {purchase_guid ? (
                  <GridLayoutItem colSpan={2}>
                    <Field
                      name="imward_no_label"
                      label="Inward No"
                      disabled={true}
                      placeholder="Inward No"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                ) : (
                  <GridLayoutItem
                    colSpan={2}
                    // style={{ display: "flex", alignItems: "end", gap: 10 }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "end", gap: 10 }}
                    >
                      <Field
                        wrapperClassName="w-100"
                        name="inward_no"
                        label="Inward No"
                        placeholder="Inward No"
                        disabled={purchase_guid ? true : false}
                        component={FormSelectionField}
                        onChange={handleInwardNoChange}
                        options={InwardList?.map((inward: any) => {
                          return {
                            value: inward?.inward_no,
                            label: `${inward?.account_name} - ${inward?.inward_no} - ${inward?.inward_date} - PO#${inward?.po_no}`,
                          };
                        })}
                      />
                      <ButtonForAll
                        label={"View"}
                        disabled={
                          purchase_guid ||
                          !formRenderProps.valueGetter("inward_no")
                            ? true
                            : false
                        }
                        // style={{ position: "absolute", top: 35 }}
                        onClick={() =>
                          handleChallanNoChange(
                            formRenderProps.valueGetter("inward_no"),
                            formRenderProps
                          )
                        }
                      />
                    </div>
                  </GridLayoutItem>
                )}
                {/* <GridLayoutItem className="position-relative"></GridLayoutItem> */}
                <GridLayoutItem>
                  <Field
                    name="invoice_no"
                    label="Bill No"
                    placeholder="Bill No"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="invoice_date"
                    label="Bill Date"
                    format="dd/MM/yyyy"
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="vendor_id"
                    label="Vendor Name"
                    placeholder="Search Vendor Name"
                    isAddNew={true}
                    addNewLink="account/create"
                    component={FormIncrementalSearch}
                    validator={requiredValidator}
                    astrike={true}
                    fetchIncrementalData={(search: any) =>
                      handleVendorSearchChange(
                        search,
                        `vendor_options`,
                        formRenderProps
                      )
                    }
                    options={
                      formRenderProps
                        .valueGetter("vendor_options")
                        ?.map((item: any) => {
                          return {
                            value: item.id,
                            label: item.account_name,
                          };
                        }) || []
                    }
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="mobile_no"
                    label="Mobile No"
                    placeholder="Mobile No"
                    component={FormTextField}
                    validator={phoneWOValueValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="email_id"
                    label="Email ID"
                    placeholder="Email ID"
                    component={FormTextField}
                    validator={emailWOValueValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="place_of_supply_id"
                    label="Place Of Supply"
                    placeholder="Place Of Supply"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={StateList?.map((state: IState) => {
                      return {
                        value: state?.id,
                        label: state?.state_name,
                      };
                    })}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem>
                  <Field
                    name="pan_no"
                    label="PAN No"
                    placeholder="PAN No"
                    component={FormTextField}
                    validator={panWOValueValidator}
                    onChange={(e) =>
                      formRenderProps.onChange("pan_no", {
                        value: e?.value?.toUpperCase(),
                      })
                    }
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="gst_no"
                    label="GST No"
                    placeholder="GST No"
                    component={FormTextField}
                    onChange={(e) =>
                      formRenderProps.onChange("gst_no", {
                        value: e?.value?.toUpperCase(),
                      })
                    }
                    validator={gstWOValueValidator}
                  />
                </GridLayoutItem> */}
                {purchase_guid && (
                  <GridLayoutItem>
                    <Field
                      name="po_no"
                      label="Purchase Order No"
                      placeholder="0"
                      component={FormTextField}
                      disabled={true}
                    />
                  </GridLayoutItem>
                )}
                {/* <GridLayoutItem>
                  <Field
                    name="purchase_ledger_id"
                    label="Purchase Ledger"
                    placeholder="Search Purchase Ledger"
                    isAddNew={true}
                    addNewLink="account/create"
                    component={FormIncrementalSearch}
                    validator={requiredValidator}
                    astrike={true}
                    fetchIncrementalData={(search: any) =>
                      handlePurchaseLedgerSearchChange(
                        search,
                        `purchase_ledger`,
                        formRenderProps
                      )
                    }
                    options={
                      formRenderProps
                        .valueGetter("purchase_ledger")
                        ?.map((item: any) => {
                          return {
                            value: item.id,
                            label: item.account_name,
                          };
                        }) || []
                    }
                  />
                </GridLayoutItem> */}
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-alighned-field"
                    name="terms_days"
                    label="Terms Day"
                    placeholder="0"
                    disabled={true}
                    maxNumber={999}
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="due_date"
                    label="Due Date"
                    format="dd/MM/yyyy"
                    disabled={true}
                    component={FormDatePicker}
                  />
                </GridLayoutItem>
                <QtyChangeWatcher formRenderProps={formRenderProps} />
                <VendorChangeWatcher formRenderProps={formRenderProps} />
                <DateChangeWatcher formRenderProps={formRenderProps} />
                <PurchaseNoChangeWatcher formRenderProps={formRenderProps} />
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ padding: 12, marginTop: 10 }}>
              <GridLayout
                style={{ marginRight: 30 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                ]}
              >
                <GridLayoutItem colSpan={4}>
                  <Typography.h4>Item Details</Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={4}
                  // style={{ borderBottom: "1px solid lightgray" }}
                >
                  <FieldArray
                    formRenderProps={formRenderProps}
                    handleItemSearchChange={handleItemSearchChange}
                    component={PurchaseItemDetailsArray}
                    name="purchase_items"
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}></GridLayoutItem>
                <GridLayoutItem
                  colSpan={2}
                  style={{ display: "flex", alignItems: "end" }}
                >
                  <div style={{ width: "100%" }}>
                    <table style={{ width: "100%" }}>
                      <tr>
                        <td
                          style={{
                            width: "50%",
                            textAlign: "end",
                            fontWeight: 600,
                          }}
                        >
                          Total
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: "45%" }}>
                          <Field
                            wrapperClassName="calculation-label"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="taxable_amount"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                </GridLayoutItem>
                <GridLayoutItem colSpan={4}>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    handleLedgerSearchChange={handleLedgerSearchChange}
                    component={DutyAndTaxDetailsArray}
                    name="purchase_duty_and_taxes"
                  />
                  {/* <PurchaseInvoiceTaxSummary
                    formRenderProps={formRenderProps}
                  /> */}
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}></GridLayoutItem>

                <GridLayoutItem
                  colSpan={2}
                  style={{ display: "flex", alignItems: "end" }}
                >
                  <div style={{ width: "100%" }}>
                    <table style={{ width: "100%" }}>
                      {/* <tr>
                        <td
                          style={{
                            width: "50%",
                            textAlign: "end",
                            fontWeight: 600,
                          }}
                        >
                          Total
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: "45%" }}>
                          <Field
                            wrapperClassName="calculation-label"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="taxable_amount"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "50%",
                            textAlign: "end",
                            fontWeight: 600,
                          }}
                        >
                          Packing
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: "45%" }}>
                          <Field
                            wrapperClassName="right-alighned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="packing"
                            format="n2"
                            placeholder="0.00"
                            component={FormNumericTextField}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "50%",
                            textAlign: "end",
                            fontWeight: 600,
                          }}
                        >
                          Labour
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: "45%" }}>
                          <Field
                            wrapperClassName="right-alighned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="labour"
                            format="n2"
                            placeholder="0.00"
                            component={FormNumericTextField}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "50%",
                            textAlign: "end",
                            fontWeight: 600,
                          }}
                        >
                          Dalali
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: "45%" }}>
                          <Field
                            wrapperClassName="right-alighned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="dalali"
                            format="n2"
                            placeholder="0.00"
                            component={FormNumericTextField}
                          />
                        </td>
                      </tr>
                      {PurchaseStateForGST === GUJARATIDFORGST && (
                        <tr>
                          <td
                            style={{
                              width: "50%",
                              textAlign: "end",
                              fontWeight: 600,
                            }}
                          >
                            CGST
                          </td>
                          <td style={{ width: "5%", textAlign: "center" }}>
                            :
                          </td>
                          <td style={{ width: "45%" }}>
                            <Field
                              wrapperClassName="calculation-label"
                              wrapperStyle={{ margin: 0, width: "100%" }}
                              name="cgst"
                              placeholder="0"
                              disabled={true}
                              format="n2"
                              component={FormNumericTextField}
                            />
                          </td>
                        </tr>
                      )}
                      {PurchaseStateForGST === GUJARATIDFORGST && (
                        <tr>
                          <td
                            style={{
                              width: "50%",
                              textAlign: "end",
                              fontWeight: 600,
                            }}
                          >
                            SGST
                          </td>
                          <td style={{ width: "5%", textAlign: "center" }}>
                            :
                          </td>
                          <td style={{ width: "45%" }}>
                            <Field
                              wrapperClassName="calculation-label"
                              wrapperStyle={{ margin: 0, width: "100%" }}
                              name="sgst"
                              placeholder="0"
                              disabled={true}
                              format="n2"
                              component={FormNumericTextField}
                            />
                          </td>
                        </tr>
                      )}
                      {PurchaseStateForGST !== GUJARATIDFORGST && (
                        <tr>
                          <td
                            style={{
                              width: "50%",
                              textAlign: "end",
                              fontWeight: 600,
                            }}
                          >
                            IGST
                          </td>
                          <td style={{ width: "5%", textAlign: "center" }}>
                            :
                          </td>
                          <td style={{ width: "45%" }}>
                            <Field
                              wrapperClassName="calculation-label"
                              wrapperStyle={{ margin: 0, width: "100%" }}
                              name="igst"
                              placeholder="0"
                              disabled={true}
                              format="n2"
                              component={FormNumericTextField}
                            />
                          </td>
                        </tr>
                      )} */}
                      <tr>
                        <td
                          style={{
                            width: "50%",
                            textAlign: "end",
                            fontWeight: 600,
                          }}
                        >
                          Sub Total
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: "45%" }}>
                          <Field
                            wrapperClassName="calculation-label"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="sub_total"
                            placeholder="0"
                            disabled={true}
                            format="n2"
                            component={FormNumericTextField}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "50%",
                            textAlign: "end",
                            fontWeight: 600,
                          }}
                        >
                          Round Off
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: "45%" }}>
                          <Field
                            wrapperClassName="calculation-label"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="round_off"
                            placeholder="0"
                            disabled={true}
                            format="n2"
                            component={FormNumericTextField}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "50%",
                            textAlign: "end",
                            fontWeight: 600,
                          }}
                        >
                          Grand Total
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: "45%" }}>
                          <Field
                            wrapperClassName="calculation-label"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="grand_total"
                            placeholder="0"
                            disabled={true}
                            format="n2"
                            component={FormNumericTextField}
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={4}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "end",
                    marginTop: 15,
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={purchase_guid ? "Update" : "Save"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      style={{ marginLeft: 4 }}
                      onClick={() =>
                        // navigate("/purchase")
                        navigate(-1)
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

const InwardChildItemDialog: React.FC = () => {
  // const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  // const InwardID = useAppSelector((state) => state.inward.InwardID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const InwardDetail = useAppSelector((state) => state.inward.InwardDetail);
  const loading = useAppSelector((state) => state.inward.loading);

  // useEffect(() => {
  //   if (InwardID) {
  //     const payload = {
  //       inward_guid: InwardID,
  //     };
  //     dispatch(getInwardByID(payload));
  //   }
  // }, [InwardID]);

  // useEffect(() => {
  //   return () => {
  //     dispatch(clearInwardDetails());
  //   };
  // }, []);

  let totalDagina = 0;
  let totalAmount = 0;

  InwardDetail &&
    InwardDetail?.inward_items &&
    InwardDetail?.inward_items.length > 0 &&
    InwardDetail?.inward_items?.forEach((item: any) => {
      totalDagina += item?.dagina || 0;
      totalAmount += item?.total || 0;
    });

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {dialogName === "inwardItemdetailsView" && (
        <AppDialog className="inward-items-dialog">
          <>
            <Typography.h5>{"Inward Items"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                {InwardDetail &&
                InwardDetail?.inward_items &&
                InwardDetail?.inward_items.length > 0 ? (
                  <div
                    className="table-responsive m-0"
                    style={{
                      maxHeight: "calc(100vh - 227px)",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ background: "black", color: "white" }}>
                            No
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Item
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Weight (Qty)
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Rate
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Discount
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Unit
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Dagina
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Total
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Warehouse
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Warehouse Receipt No
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {InwardDetail?.inward_items?.map(
                          (item: any, index: number) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item?.item_name}</td>
                              <td className="text-end">
                                {formatIndianNumberForQty(item?.weight || 0)}
                              </td>
                              <td className="text-end">
                                {formatIndianNumber(item?.rate || 0, 4)}
                              </td>
                              <td className="text-end">
                                {item?.discount_type === "₹"
                                  ? `₹ ${formatIndianNumber(
                                      item?.discount || 0,
                                      4
                                    )}`
                                  : `${item?.discount} %`}
                              </td>
                              <td>{item?.unit_name}</td>
                              <td className="text-end">{item?.dagina}</td>
                              <td className="text-end">
                                {item?.total
                                  ? formatIndianNumber(item?.total)
                                  : ""}
                              </td>
                              <td>{item?.warehouse_name}</td>
                              <td>{item?.receipt_no}</td>
                            </tr>
                          )
                        )}
                        <tr className="fw-bold">
                          <td
                            colSpan={6}
                            className="text-end pe-5"
                            style={{
                              background: "lightgray",
                              color: "black",
                            }}
                          >
                            Total
                          </td>
                          <td
                            style={{
                              textAlign: "end",
                              background: "lightgray",
                              color: "black",
                            }}
                          >
                            {totalDagina}
                          </td>
                          <td
                            style={{
                              textAlign: "end",
                              background: "lightgray",
                              color: "black",
                            }}
                          >
                            {formatIndianNumber(Math.round(totalAmount))}
                          </td>
                          <td
                            style={{
                              background: "lightgray",
                              color: "black",
                            }}
                          ></td>
                          <td
                            style={{
                              background: "lightgray",
                              color: "black",
                            }}
                          ></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <AlertBox style={{ marginBottom: 10 }} />
                )}
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: 20,
                }}
              >
                <DialogCloseButton themeColor="error" />
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

// const PurchaseInvoiceTaxSummary: React.FC<FormChangeWatcherProps> = ({
//   formRenderProps,
// }) => {
//   const location = useLocation();
//   const PurchaseStateForGST = useAppSelector(
//     (state) => state.purchase.PurchaseStateForGST
//   );
//   const purchase_guid = location.state?.purchase_guid;
//   const PurchaseDetail = useAppSelector(
//     (state) => state.purchase.PurchaseDetail
//   );
//   const isVendorRef = useRef(true);
//   const [isIGST, setIsIgst] = React.useState<boolean>(false);

//   const totalGST = formRenderProps.valueGetter("gst");
//   const totalGST5 = formRenderProps.valueGetter("gst5");
//   const totalGST12 = formRenderProps.valueGetter("gst12");
//   const totalGST18 = formRenderProps.valueGetter("gst18");
//   const totalGST28 = formRenderProps.valueGetter("gst28");

//   useEffect(() => {
//     if (purchase_guid) {
//       if (!isVendorRef.current) {
//         setIsIgst(PurchaseStateForGST !== GUJARATIDFORGST);
//       } else {
//         if (PurchaseDetail?.igst && PurchaseDetail?.igst !== null) {
//           setIsIgst(true);
//         } else {
//           setIsIgst(false);
//         }
//         isVendorRef.current = false;
//       }
//     } else {
//       setIsIgst(PurchaseStateForGST !== GUJARATIDFORGST);
//     }
//   }, [PurchaseStateForGST]);

//   return (
//     <>
//       <div>
//         <table style={{ width: "100%" }} className="sctaxsummary-table">
//           {(totalGST5 > 0 ||
//             totalGST12 > 0 ||
//             totalGST18 > 0 ||
//             totalGST28 > 0) && (
//             <tr style={{ background: "lightgray" }}>
//               <td colSpan={4}>
//                 <h5 className="m-0">Tax Summery</h5>
//               </td>
//             </tr>
//           )}
//           {isIGST && totalGST5 > 0 && (
//             <tr>
//               <td
//                 style={{
//                   width: "30%",
//                   fontWeight: 600,
//                 }}
//               >
//                 IGST 5%
//               </td>
//               <td style={{ width: "10%", textAlign: "center" }}>:</td>
//               <td style={{ width: "10%", textAlign: "center" }}>5 %</td>
//               <td
//                 style={{
//                   width: "50%",
//                   textAlign: "right",
//                   paddingRight: 45,
//                 }}
//               >
//                 {formatIndianNumber(totalGST5)}
//               </td>
//             </tr>
//           )}
//           {isIGST && totalGST12 > 0 && (
//             <tr>
//               <td
//                 style={{
//                   width: "30%",
//                   fontWeight: 600,
//                 }}
//               >
//                 IGST 12%
//               </td>
//               <td style={{ width: "10%", textAlign: "center" }}>:</td>
//               <td style={{ width: "10%", textAlign: "center" }}>12 %</td>
//               <td
//                 style={{
//                   width: "50%",
//                   textAlign: "right",
//                   paddingRight: 45,
//                 }}
//               >
//                 {formatIndianNumber(totalGST12)}
//               </td>
//             </tr>
//           )}
//           {isIGST && totalGST18 > 0 && (
//             <tr>
//               <td
//                 style={{
//                   width: "30%",
//                   fontWeight: 600,
//                 }}
//               >
//                 IGST 18%
//               </td>
//               <td style={{ width: "10%", textAlign: "center" }}>:</td>
//               <td style={{ width: "10%", textAlign: "center" }}>18 %</td>
//               <td
//                 style={{
//                   width: "50%",
//                   textAlign: "right",
//                   paddingRight: 45,
//                 }}
//               >
//                 {formatIndianNumber(totalGST18)}
//               </td>
//             </tr>
//           )}
//           {isIGST && totalGST28 > 0 && (
//             <tr>
//               <td
//                 style={{
//                   width: "30%",
//                   fontWeight: 600,
//                 }}
//               >
//                 IGST 28%
//               </td>
//               <td style={{ width: "10%", textAlign: "center" }}>:</td>
//               <td style={{ width: "10%", textAlign: "center" }}>28 %</td>
//               <td
//                 style={{
//                   width: "50%",
//                   textAlign: "right",
//                   paddingRight: 45,
//                 }}
//               >
//                 {formatIndianNumber(totalGST28)}
//               </td>
//             </tr>
//           )}
//           {!isIGST && totalGST5 > 0 && (
//             <>
//               <tr>
//                 <td
//                   style={{
//                     width: "30%",
//                     fontWeight: 600,
//                   }}
//                 >
//                   CGST 2.5%
//                 </td>
//                 <td style={{ width: "10%", textAlign: "center" }}>:</td>
//                 <td style={{ width: "10%", textAlign: "center" }}>2.5 %</td>
//                 <td
//                   style={{
//                     width: "50%",
//                     textAlign: "right",
//                     paddingRight: 45,
//                   }}
//                 >
//                   {formatIndianNumber(totalGST5 / 2)}
//                 </td>
//               </tr>
//               <tr>
//                 <td
//                   style={{
//                     width: "30%",
//                     fontWeight: 600,
//                   }}
//                 >
//                   SGST 2.5%
//                 </td>
//                 <td style={{ width: "10%", textAlign: "center" }}>:</td>
//                 <td style={{ width: "10%", textAlign: "center" }}>2.5 %</td>
//                 <td
//                   style={{
//                     width: "50%",
//                     textAlign: "right",
//                     paddingRight: 45,
//                   }}
//                 >
//                   {formatIndianNumber(totalGST5 / 2)}
//                 </td>
//               </tr>
//             </>
//           )}
//           {!isIGST && totalGST12 > 0 && (
//             <>
//               <tr>
//                 <td
//                   style={{
//                     width: "30%",
//                     fontWeight: 600,
//                   }}
//                 >
//                   CGST 6%
//                 </td>
//                 <td style={{ width: "10%", textAlign: "center" }}>:</td>
//                 <td style={{ width: "10%", textAlign: "center" }}>6 %</td>
//                 <td
//                   style={{
//                     width: "50%",
//                     textAlign: "right",
//                     paddingRight: 45,
//                   }}
//                 >
//                   {formatIndianNumber(totalGST12 / 2)}
//                 </td>
//               </tr>
//               <tr>
//                 <td
//                   style={{
//                     width: "30%",
//                     fontWeight: 600,
//                   }}
//                 >
//                   SGST 6%
//                 </td>
//                 <td style={{ width: "10%", textAlign: "center" }}>:</td>
//                 <td style={{ width: "10%", textAlign: "center" }}>6 %</td>
//                 <td
//                   style={{
//                     width: "50%",
//                     textAlign: "right",
//                     paddingRight: 45,
//                   }}
//                 >
//                   {formatIndianNumber(totalGST12 / 2)}
//                 </td>
//               </tr>
//             </>
//           )}
//           {!isIGST && totalGST18 > 0 && (
//             <>
//               <tr>
//                 <td
//                   style={{
//                     width: "30%",
//                     fontWeight: 600,
//                   }}
//                 >
//                   CGST 9%
//                 </td>
//                 <td style={{ width: "10%", textAlign: "center" }}>:</td>
//                 <td style={{ width: "10%", textAlign: "center" }}>9 %</td>
//                 <td
//                   style={{
//                     width: "50%",
//                     textAlign: "right",
//                     paddingRight: 45,
//                   }}
//                 >
//                   {formatIndianNumber(totalGST18 / 2)}
//                 </td>
//               </tr>
//               <tr>
//                 <td
//                   style={{
//                     width: "30%",
//                     fontWeight: 600,
//                   }}
//                 >
//                   SGST 9%
//                 </td>
//                 <td style={{ width: "10%", textAlign: "center" }}>:</td>
//                 <td style={{ width: "10%", textAlign: "center" }}>9 %</td>
//                 <td
//                   style={{
//                     width: "50%",
//                     textAlign: "right",
//                     paddingRight: 45,
//                   }}
//                 >
//                   {formatIndianNumber(totalGST18 / 2)}
//                 </td>
//               </tr>
//             </>
//           )}
//           {!isIGST && totalGST28 > 0 && (
//             <>
//               <tr>
//                 <td
//                   style={{
//                     width: "30%",
//                     fontWeight: 600,
//                   }}
//                 >
//                   CGST 14%
//                 </td>
//                 <td style={{ width: "10%", textAlign: "center" }}>:</td>
//                 <td style={{ width: "10%", textAlign: "center" }}>14 %</td>
//                 <td
//                   style={{
//                     width: "50%",
//                     textAlign: "right",
//                     paddingRight: 45,
//                   }}
//                 >
//                   {formatIndianNumber(totalGST28 / 2)}
//                 </td>
//               </tr>
//               <tr>
//                 <td
//                   style={{
//                     width: "30%",
//                     fontWeight: 600,
//                   }}
//                 >
//                   SGST 14%
//                 </td>
//                 <td style={{ width: "10%", textAlign: "center" }}>:</td>
//                 <td style={{ width: "10%", textAlign: "center" }}>14 %</td>
//                 <td
//                   style={{
//                     width: "50%",
//                     textAlign: "right",
//                     paddingRight: 45,
//                   }}
//                 >
//                   {formatIndianNumber(totalGST28 / 2)}
//                 </td>
//               </tr>
//             </>
//           )}

//           {!isIGST && totalGST > 0 && (
//             <>
//               <tr style={{ background: "whitesmoke" }}>
//                 <td
//                   style={{
//                     width: "30%",
//                     fontWeight: 600,
//                   }}
//                 >
//                   Total CGST
//                 </td>
//                 <td style={{ width: "10%", textAlign: "center" }}>:</td>
//                 <td style={{ width: "10%", textAlign: "center" }}></td>
//                 <td
//                   style={{
//                     width: "50%",
//                     textAlign: "right",
//                     paddingRight: 45,
//                   }}
//                 >
//                   {formatIndianNumber(totalGST / 2)}
//                 </td>
//               </tr>
//               <tr style={{ background: "whitesmoke" }}>
//                 <td
//                   style={{
//                     width: "30%",
//                     fontWeight: 600,
//                   }}
//                 >
//                   Total SGST
//                 </td>
//                 <td style={{ width: "10%", textAlign: "center" }}>:</td>
//                 <td style={{ width: "10%", textAlign: "center" }}></td>
//                 <td
//                   style={{
//                     width: "50%",
//                     textAlign: "right",
//                     paddingRight: 45,
//                   }}
//                 >
//                   {formatIndianNumber(totalGST / 2)}
//                 </td>
//               </tr>
//             </>
//           )}
//           {isIGST && totalGST > 0 && (
//             <tr style={{ background: "whitesmoke" }}>
//               <td
//                 style={{
//                   width: "30%",
//                   fontWeight: 600,
//                 }}
//               >
//                 Total IGST
//               </td>
//               <td style={{ width: "10%", textAlign: "center" }}>:</td>
//               <td style={{ width: "10%", textAlign: "center" }}></td>
//               <td
//                 style={{
//                   width: "50%",
//                   textAlign: "right",
//                   paddingRight: 45,
//                 }}
//               >
//                 {formatIndianNumber(totalGST)}
//               </td>
//             </tr>
//           )}
//         </table>
//       </div>
//     </>
//   );
// };

export default CreatePurchase;
